export const oneTrustDomainsID = [
  { market: 'tr', id: '09f1c894-2c3f-4626-977c-910163434b5b', host: 'www.enuygun.com' },
  { market: 'tr', id: '018f7189-4247-7e27-a166-7e5de8f58251', host: 'enuygunsigorta.com' },
]
